<template>
  <div
    class="p-4 flex justify-between items-center border border-surface-grey rounded-md hover:opacity-50 transition"
    @click="websocket.doPlaceOrder(paymentMethod)"
  >
    <div class="flex md:flex-row flex-col md:justify-between">
      <div class="font-semibold w-40">{{ title }}</div>
      <div class="flex md:flex-row flex-col md:gap-4">
        {{ formatPrice(price, 'DKK', $i18n.locale) }}

        <span class="font-semibold text-success" v-if="discount">
          {{ formatPrice(discount, 'DKK', $i18n.locale) }}
          {{ $t('common.discount') }}
        </span>
      </div>
    </div>

    <slot />
  </div>
</template>

<script setup lang="ts">
  import { formatPrice } from '@/utils/formatPrice';
  import { useWebsocketStore } from '@/websocket/websocket';
  const websocket = useWebsocketStore(); // for doPlaceOrder on click of creditcard images

  defineProps<{
    title: string;
    paymentMethod: string;
    price: number;
    discount?: number | null;
  }>();
</script>
